<cdx-svg-icon
  fill="dark"
  name="soup-bowl-steaming"
  size="extra-large"
></cdx-svg-icon>
<h1 class="heading--2" i18n="@@noMealPlansHeading">It looks like you haven't tried My Meal Planner yet</h1>
<p class="heading--4" i18n="@@noMealPlansDescription">Your choice of fresh dinner ideas every week - Flexible, delicious, stress-free.</p>
<button cdxButton fillStyle="primary" size="default" type="button" (click)="handleLearnHowItWorksClick()" i18n="@@noMealPlansLearnButton">Learn how it works</button>
